// util classes


const orderReducer = (
  state = {
    retailers: [],
    orderDetails: [],
    orderTab: { active: false, activeTabName: 'AllOrders' },
    skuMaster: [],
    cart: [],
    companyDetails: {},
  },
  action,
) => {
  switch (action.type) {
    case 'CLEAR_ORDER':
      return {
        ...state,
        cart: [],
        orderDetails: [],
      };
    case 'CLEAR_RETAILERS':
      return {
        ...state,
        retailers: [],
      };
    case 'SET_ORDER_DETAILS':
      return {
        ...state,
        orderDetails: action.data,
      };
    case 'SET_ORDER_TAB':
      return {
        ...state,
        orderTab: action.data,
    };
    case 'SET_SKU_MASTER':
      return { ...state, skuMaster: action.data };
    default:
      return state;
  }
};

export default orderReducer;
